import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SharedService } from './shared.service';
import { ServerResponse, ServerResponseObject } from '../interfaces/ServerResponse';
import { Observable } from 'rxjs';
import { PostUser, UpdateUser, User, Users } from '../interfaces/admin/Users';
import { Companies, Company, PostCompany } from '../interfaces/admin/Company';
import { GetDataService, GetDataServices, PostDataService } from '../interfaces/DataService';
import { AllRoles, Role, PostRole } from '../interfaces/admin/Role';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  API_URL = environment.API_URL;
  
  constructor(private http: HttpClient, public shared: SharedService) { }

  ListUsers(search_text: string, page: number, records: number): Observable<ServerResponseObject<Users>> {
    let url = `${this.API_URL}/admin/users_list`;
    const params = new HttpParams({
      fromObject: {
        search_text,
        page,
        records
      }
    });
    return this.http.get<ServerResponseObject<Users>>(url, {
      params
    })
  }

  addUser(user: PostUser){
    let url = `${this.API_URL}/admin/new_user`;
    return this.http.post<ServerResponseObject<User>>(url, user)
  }

  updateUser(user: UpdateUser){
    let url = `${this.API_URL}/admin/update_user`;
    return this.http.put<ServerResponseObject<User>>(url, user)
  }

  getRoles(search_text: string, page: number, records: number){
    let url = `${this.API_URL}/admin/roles_list_detail`;
    const params = new HttpParams({
      fromObject: {
        search_text,
        page,
        records
      }
    });
    return this.http.get<ServerResponseObject<AllRoles>>(url, {
      params
    })
  }

  ListUserRoles(user_UUID: string){
    let url = `${this.API_URL}/admin/user_roles_list`;
    const params = new HttpParams({
      fromObject: {
        user_UUID
      }
    });
    return this.http.get<ServerResponseObject<Role>>(url, {
      params
    })
  }

  setUserRolesByList(rolesList: PostRole){
    let url = `${this.API_URL}/admin/add_remove_user_roles_byList`;
    return this.http.post<ServerResponseObject<any>>(url, rolesList)
  }

  ListCompanies(search_text: string, page: number, records: number){
    let url = `${this.API_URL}/company/company_list`;
    const params = new HttpParams({
      fromObject: {
        search_text,
        page,
        records
      }
    });
    return this.http.get<ServerResponseObject<Companies>>(url, {
      params
    })
  }

  addCompany(company: PostCompany){
    let url = `${this.API_URL}/company/company`;
    return this.http.post<ServerResponseObject<Company>>(url, company)
  }

  ListDataServices(search_text: string, page: number, records: number, company_id: string = "") {
    let url = `${this.API_URL}/company/company_dataservice_list`;
    const params = new HttpParams({
      fromObject: {
        company_id,
        search_text,
        page,
        records
      }
    });
    return this.http.get<ServerResponseObject<GetDataServices>>(url, {
      params
    })
  }

  ListDataServicesByCompany(company_id: string, search_text: string, page: number, records: number) {
    let url = `${this.API_URL}/company/company_dataservice_list_by_company`;
    const params = new HttpParams({
      fromObject: {
        company_id,
        search_text,
        page,
        records
      }
    });
    return this.http.get<ServerResponseObject<GetDataServices>>(url, {
      params
    })
  }

  addDataService(dataservice: PostDataService){
    let url = `${this.API_URL}/company/company_dataservice`;
    return this.http.post<ServerResponseObject<GetDataService>>(url, dataservice)
  }

  addUserCompany(company_id: string, user: string){
    let url = `${this.API_URL}/company/user_company`;
    return this.http.post<ServerResponseObject<any>>(url, { company_id, user })
  }

  addUserDataservice(company_id: string, dataservice_id: string, user: string){
    let url = `${this.API_URL}/company/user_company_dataservice`;
    return this.http.post<ServerResponseObject<any>>(url, { company_id, dataservice_id, user })
  }

  getUserDataservice(user: string){
    let url = `${this.API_URL}/company/company_dataservice_list_by_user`;
    const params = new HttpParams({
      fromObject: {
        user
      }
    });
    return this.http.get<ServerResponse<GetDataService>>(url, {
      params
    })
  }

  getUserCompanies(user: string){
    let url = `${this.API_URL}/company/company_list_by_user`;
    const params = new HttpParams({
      fromObject: {
        user
      }
    });
    return this.http.get<ServerResponse<Company>>(url, {
      params
    })
  }

  removeUserCompany(company_id: string, user: string){
    let url = `${this.API_URL}/company/remove_user_company`;
    return this.http.post<ServerResponseObject<any>>(url, { company_id, user })
  }

  removeUserDataService(company_id: string, dataservice_id: string, user: string){
    let url = `${this.API_URL}/company/remove_user_company_dataservice`;
    return this.http.post<ServerResponseObject<any>>(url, { company_id, dataservice_id, user })
  }

}
